import { Stain } from "pwapi";

import { StainList } from "custom-models/frontLoader";

import { LabStainsState, StainsState } from "reducers/frontLoaderReducers";

export const getStainByLabStainId = (
  labStainId: number | undefined,
  stains: StainsState,
  labStains: LabStainsState
): StainList | undefined => {
  if (!labStainId) return undefined;
  const labStain = labStains[labStainId];
  if (!labStain) {
    // TODO: Raise warning in Sentry
    return undefined;
  }

  const stain = stains[labStain.stain_id];
  if (!stain) {
    // TODO: Raise warning in Sentry
    return undefined;
  }
  return stain;
};

export const stainConsideredHE = (stain?: Stain | StainList) => {
  if (!stain) return false;
  if (stain.name === "H&E" || stain.abbreviation === "H&E") return true;
  if (stain.name === "Re-Embed" || stain.abbreviation === "REMBD") return true;
  if (stain.name === "Reprocess" || stain.abbreviation === "REPRO") return true;
  if (stain.name === "Deeper Epidermis" || stain.abbreviation === "DEEPEP")
    return true;
  if (stain.name === "Deepers Exhaust" || stain.abbreviation === "DEEPEX")
    return true;
  if (stain.name === "Alopecia" || stain.abbreviation === "ALOP") return true;

  // Recuts
  if (/R x \d/.test(stain.name) || /RCT\d/.test(stain.abbreviation))
    return true;
  // Deepers
  if (/D x \d/.test(stain.name) || /D x \d/.test(stain.abbreviation))
    return true;
  // Deeper Deepers
  if (/Dx\d/.test(stain.name) || /DP\d/.test(stain.abbreviation)) return true;
  // Alopecia
  if (/L\d Alopecia/.test(stain.name) || /ALO\d/.test(stain.abbreviation))
    return true;
  // Exhaust
  if (/EXH x \d/.test(stain.name) || /EXH\d/.test(stain.abbreviation))
    return true;

  // First/Last H&Es
  if (
    stain.name.toUpperCase() === "FIRST H&E" ||
    stain.name.toUpperCase() === "LAST H&E" ||
    stain.abbreviation === "FHE" ||
    stain.abbreviation === "LHE"
  )
    return true;

  return false;
};
